module.exports = ".form-row {\n  flex-wrap: nowrap; }\n\nform.dropdown-menu {\n  cursor: pointer; }\n"